<div class="flex-col justify-center items-start">
    <p class="top-text mt-3 ml-3">{{counter()}}</p>
    <p class="bottom-text ml-3">{{title()}}</p>
</div>